import axios from "axios";
import { ADD_MORE_CARS } from "@/store/mutationTypes";
import { GET_MORE_CARS } from "@/store/actionTypes";

export default {
  async [GET_MORE_CARS]({ state, commit }) {
    const { nextPage } = state;
    const response = await axios.get(nextPage);

    state.nextPage = response.data.next;
    commit(ADD_MORE_CARS, response.data.results);
  }
};
